import React, { useState } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import SaveTermQuoteIcon from '../../../../icons/SaveTermQuote.svg';
import { makeStyles } from "@material-ui/core/styles";
import './SaveQuoteButton.scss'
import SaveQuote from './SaveQuote';
import { Button } from '@material-ui/core';

const white = "#ffffff";
const offWhite = "rgba(0, 0, 0, 0.01)"

const useStyles = makeStyles(theme => ({
    white: {
        color: theme.palette.primary.main,
        backgroundColor: white,
        '&:hover': {
            color: theme.palette.primary.main,
            backgroundColor: offWhite
        },
        '&:focus': {
            outline: 'none'
        }
    },
    lightBackground: {
        backgroundColor: `${theme.palette.primary.main}16`,
    },

}));

export default function SaveQuoteButton(props) {
    const classes = useStyles();

    const title = props.title || "NEEDS ANALYSIS";

    const [modalSaveQuoteIsOpen, setModalSaveQuoteIsOpen] = useState(false);

    const modalSaveTermQuoteFields = {
        modalSaveQuoteIsOpen: modalSaveQuoteIsOpen,
        setModalSaveQuoteIsOpen: setModalSaveQuoteIsOpen,
        loading: props.loading,
        quoteLogId: props.quoteLogId,
        errorMessage: props.errorMessage,
        setErrorMessage: props.setErrorMessage,
        setQuoteSaved: props.setQuoteSaved,
        isQuoteSaved: props.isQuoteSaved
    };

    return (
        <div className="save-term-quote-btn">
            <React.Fragment>
                <Button type="submit"
                    onClick={() => setModalSaveQuoteIsOpen(true)}
                    variant="contained"
                    color="primary"
                    className={`save-term-button ${classes.white}`}
                >
                    <span className="name">&nbsp;{title}</span> <span className="icon"><SvgIcon component={SaveTermQuoteIcon} color="primary" /></span>
                </Button>
                <SaveQuote setEmailPrefill={(e) => props.setEmailPrefill(e)} setQuoteEmail={() => props.setQuoteEmail()} fields={modalSaveTermQuoteFields}/>
            </React.Fragment>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/SaveTermQuote/SaveQuoteButton.js